/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { css } from 'glamor';

type Props = {
  children: React.ChildrenArray<React.Node>,
};

const List = glamorous.ul(({ theme }) => ({
  display: 'flex',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  alignItems: 'stretch',
  WebkitOverflowScrolling: 'touch',
  [theme.mediaQuery.desktopAndUp]: {
    overflowX: 'hidden',
  },
}));

function TabSet({
  children,
}: Props) {
  const className = css({
    flexBasis: `${100 / React.Children.count(children)}%`,
  }).toString();

  return (
    <List>
      {React.Children.map(children, child => (
        React.isValidElement(child) ?
          React.cloneElement(child, { ...child.props, className }) :
          null
      ))}
    </List>
  );
}
export default TabSet;
